import { styles } from './NavChip.css';
import React from 'react';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { Link } from '../PlatformFunctionality';

export type NavChipProps = {
  label: string;
  href: string;
  className?: string;
};

export const NavChip = ({ label, href, className }: NavChipProps) => {
  return (
    <Link href={href} className={classNames(styles.navChip, className)}>
      {label}
    </Link>
  );
};
